import { useAuth } from '@/contexts/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Shield, Mail, Phone } from 'lucide-react';

export const SuspensionNotice = () => {
  const { clearSuspension } = useAuth();

  const handleContactSupport = () => {
    window.location.href = 'mailto:support@statconsult.org?subject=Account Suspension Appeal';
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <Shield className="h-16 w-16 text-destructive" />
          </div>
          <CardTitle className="text-2xl text-destructive">Account Suspended</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="text-center space-y-4">
            <p className="text-muted-foreground">
              Your account has been temporarily suspended due to a violation of our terms of service or community guidelines.
            </p>
            
            <div className="bg-muted/50 p-4 rounded-lg space-y-2">
              <h4 className="font-semibold text-sm">What this means:</h4>
              <ul className="text-sm text-muted-foreground space-y-1">
                <li>• You cannot access platform features</li>
                <li>• Your profile is temporarily hidden</li>
                <li>• Existing projects may be affected</li>
              </ul>
            </div>

            <div className="bg-blue-50 dark:bg-blue-950/20 border border-blue-200 dark:border-blue-800 p-4 rounded-lg space-y-2">
              <h4 className="font-semibold text-sm text-blue-900 dark:text-blue-100">Next Steps:</h4>
              <p className="text-sm text-blue-800 dark:text-blue-200">
                Contact our support team to discuss your account status and appeal the suspension if you believe this was done in error.
              </p>
            </div>
          </div>

          <div className="space-y-3">
            <Button 
              onClick={handleContactSupport}
              className="w-full"
              size="lg"
            >
              <Mail className="h-4 w-4 mr-2" />
              Contact Support
            </Button>
            
            <div className="text-center">
              <p className="text-xs text-muted-foreground">
                Support Email: support@statconsult.org
              </p>
              <p className="text-xs text-muted-foreground">
                Response time: 24-48 hours
              </p>
            </div>
          </div>

          <div className="text-center">
            <Button 
              variant="outline"
              onClick={clearSuspension}
              size="sm"
            >
              Back to Login
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};